<template>
  <div :id="'autocomp-' + _uid" :class="[ isGroup ? 'input-group' : '', 'autocomplete-outer' ]">
    <input
      autocomplete="off"
      @input="updating"
      :autofocus="autoFocus"
      :data-toggle="title ? 'tooltip' : ''"
      :placeholder="placeHolder"
      :title="title"
      type="text"
      :id="acId"
      class="form-control"
      v-model="search"
      @focus="shouldShow = true"
      :style="inputStyles"/>
    <ul :id="id" :style="ulStyles" v-show="showList" class="auto-complete-ul">
      <li v-for="(match, i) in formattedDataset" @mouseover="highlightIndex=i" :class="[ highlightIndex === i ? 'hover' : '', 'search-item' ]" @click="searchSelect(match)">
        {{ value(match) }}
      </li>
    </ul>
    <span class="input-group-addon" v-if="isGroup" v-for="addon in groupAddons">
      <i :class="['fa', addon.icon]" @click="addon.fn"></i>
    </span>
  </div>
</template>
<script>
  import $ from 'jquery'
  import event from '../../event'
  export default {
    name: 'AutoComplete',
    props: {
      dataset: {
        type: Array
      },
      id: {
        type: String
      },
      isVisible: null,
      styles: Object,
      placeHolder: String,
      title: String,
      isHtml: null,
      fnFormatText: Function,
      fnFilter: Function,
      fnSelectValue: Function,
      groupAddons: null,
      initVal: null,
      autoFocus: {
        type: Boolean,
        default: false
      }
    },
    // props: ['dataset', 'id', 'isVisible', 'styles', 'placeHolder', 'title', 'isHtml', 'fnFormatText', 'fnFilter', 'fnSelectValue', 'groupAddons', 'initVal'],
    data () {
      return {
        isInitialised: false,
        search: '',
        width: 0,
        zIndex: 0,
        shouldShow: false,
        selectionMade: false,
        selection: null,
        highlightIndex: null,
        inputChanged: false
      }
    },
    watch: {
      isVisible (newVal, oldVal) {
        this.calcWidth()
      },
      initVal (newVal, oldVal) {
        if (typeof newVal === 'object' && newVal !== null && typeof newVal !== 'undefined' && Object.keys(newVal).length === 0) {
          /* No Op */
        } else if (newVal && (JSON.stringify(newVal) !== JSON.stringify(this.selection))) {
          this.inputChanged = true
          let obj = this.createObject(newVal)
          this.searchSelect(obj)
        } else if (newVal && (JSON.stringify(newVal) === JSON.stringify(this.selection)) && this.search === '') {
          this.inputChanged = true
          let obj = this.createObject(newVal)
          this.searchSelect(obj)
        } else if (!newVal) {
          this.search = ''
        }
      },
      search (newVal, oldVal) {
        this.calcWidth()
        if (this.shouldShow && !this.selectionMade) {
          this.debounceAndEmit(newVal)
        }
      }
    },
    methods: {
      /*
      * Simple debounce implementation that prevents
      * multiple events firing if events can/should
      * be grouped into one event
      */
      debounceAndEmit (newVal) {
        setTimeout(() => {
          if (newVal === this.search) {
            let emitValue = newVal
            if (emitValue === JSON.stringify({})) {
              emitValue = null
            }
            this.$emit('changing', emitValue)
          }
        }, 250)
      },
      value (match) {
        return typeof match === 'object' && match.hasOwnProperty('autoCompleteValue') ? match.autoCompleteValue : match
      },
      updating () {
        this.inputChanged = true
        this.shouldShow = true
        this.selectionMade = false
      },
      calcWidth () {
        this.width = $('#ac-' + this._uid).outerWidth()
      },
      calcZIndex () {
        let z = $('#autocomp-' + this._uid).css('z-index')
        let zVal = parseInt(z)
        if (!isNaN(zVal) && zVal !== 9999) {
          this.zIndex = zVal + 1
        } else {
          this.zIndex = 9999
        }
      },
      searchSelect (match) {
        if (this.inputChanged || this.isSettingUp) {
          this.shouldShow = false
          this.selectionMade = true
          this.search = match.hasOwnProperty('autoCompleteSelectedValue') ? match.autoCompleteSelectedValue : match.initValue
          let emitValue = null
          if (match.hasOwnProperty('initValue')) {
            emitValue = match.initValue
          } else {
            emitValue = Object.assign({}, match)
            delete emitValue.autoCompleteValue
            delete emitValue.autoCompleteSelectedValue
          }
          if (this.isInitialised) {
            if (emitValue === JSON.stringify({})) {
              emitValue = null
            }
            if (JSON.stringify(emitValue) !== JSON.stringify(this.selection)) {
              this.$emit('selection-made', emitValue)
              this.selection = emitValue
            }
          }
        }
        this.inputChanged = false
      },
      createObject (item) {
        let obj = {}
        if (typeof item !== 'object') {
          obj.initValue = item
        } else {
          obj = Object.assign({}, item)
        }
        obj.autoCompleteSelectedValue = this.fnSelectValue ? this.fnSelectValue(item) : item
        obj.autoCompleteValue = this.fnFormatText ? this.fnFormatText(item) : item
        return obj
      },
      setUp () {
        this.calcWidth()
        this.calcZIndex()
      },
      loseFocus (event) {
        try {
          const thisComponent = document.getElementById('autocomp-' + this._uid)
          if (thisComponent) {
            const isClickInside = thisComponent.contains(event.target)
            if (!isClickInside) {
              this.shouldShow = false
              this.search = this.selectionMade ? this.search : ''
              this.highlightIndex = null
              if (!this.selectionMade) {
                this.searchSelect({})
              }
            }
          }
        } catch (err) {
          console.log(err.message)
        }
      },
      tab () {
        const match = this.formattedDataset[this.highlightIndex || 0] || {}
        this.searchSelect(match)
      },
      down () {
        if (this.highlightIndex === null) {
          this.highlightIndex = 0
          this.scroll(true)
        } else if (this.highlightIndex < this.formattedDataset.length - 1) {
          this.highlightIndex = this.highlightIndex + 1
          this.scroll(true)
        }
      },
      up () {
        if (this.highlightIndex > 0) {
          this.highlightIndex = this.highlightIndex - 1
          this.scroll(false)
        } else {
          this.highlightIndex = null
        }
      },
      keys (e) {
        if (this.showList) {
          if (e.keyCode === 9) {
            this.tab()
          } else if (e.keyCode === 38) {
            this.up()
          } else if (e.keyCode === 40) {
            this.down()
          }
        }
      },
      scroll (bool) {
        const list = this.$el.querySelector('.auto-complete-ul')
        if (bool && this.highlightIndex > 0 && (this.highlightIndex < this.formattedDataset.length)) {
          list.scrollTop = list.scrollTop + 26
        } else if (!bool && this.highlightIndex > 0) {
          list.scrollTop = list.scrollTop - 26
        }
      },
      focusInput () {
        if (this.autoFocus) {
          document.getElementById(this.acId).focus()
        }
      }
    },
    computed: {
      acId () {
        return 'ac-' + this._uid
      },
      ulStyles () {
        let obj = {}
        if (typeof this.styles !== 'undefined' && typeof this.styles.ul !== 'undefined') {
          obj = { ...this.styles.ul }
        }
        return {
          width: this.width + 'px',
          zIndex: this.zIndex,
          top: '34px',
          ...obj
        }
      },
      isSettingUp () {
        return !this.inputChanged && !this.isInitialised
      },
      isGroup () {
        return typeof this.groupAddons !== 'undefined' && this.groupAddons.length
      },
      showList () {
        return String(this.search).trim().length > 1 && this.shouldShow
      },
      inputStyles () {
        if (typeof this.styles !== 'undefined' && typeof this.styles.input !== 'undefined') {
          return this.styles.input
        }
        return {}
      },
      formattedDataset () {
        return this.dataset.map((item) => {
          return this.createObject(item)
        })
      },
      matches () {
        let searchString = this.search
        return this.formattedDataset.filter((item) => {
          return this.fnFilter(searchString, item)
        })
      }
    },
    created () {
      if (this.initVal) {
        let obj = this.createObject(this.initVal)
        this.searchSelect(obj)
      }
      this.isInitialised = true
      event.$on('window-resizing', this.setUp)
    },
    mounted () {
      this.$nextTick(() => {
        this.setUp()
        document.addEventListener('click', this.loseFocus, { passive: true })
        document.addEventListener('keydown', this.keys, { passive: true })
        setTimeout(this.focusInput, 100)
      })
    },
    beforeDestroy () {
      document.removeEventListener('click', this.loseFocus)
      document.removeEventListener('keydown', this.keys)
      event.$off('window-resizing', this.setUp)
    }
  }
</script>

<style scoped>
.autocomplete-outer {
  position: relative;
}
ul {
  padding: 0 !important;
  margin: 0 !important;
  position: absolute;
  background: #fff;
  border: 1px solid #eee;
  list-style-type: none;
  opacity:1;
  max-height: 150px;
  overflow: auto;
}
li {
  background: #fff;
  color: #000;
  padding: 3px;
}
li.hover {
  background-color: #eee;
  font-weight:bold;
  padding-left: 3px;
  cursor: pointer;
}
.fa {
   cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// AutoComplete.vue?2455eb81